<template>
    <div class="layout-container">
        <div class="tab-items" v-for="item in homes" v-if="homes.length>0">
            <template>
                <div>
                    <component :is="item.htmlContent" :item="item"></component>
                </div>
            </template>
        </div>
        <div class="kefu" v-if="kfUrl" @click="toKF"><i class="el-icon-headset"></i></div>
    </div>
</template>

<script>
    import TabPlus from "./plus/index";
    import TabCats from "./list/cats";
    import TabVideos from "./list/videos";
    import Lunbo from "./lunbo/lunbo";
    import TabMs from "./ms/ms";
    import TabBp from "./../common/bp/bp";
    import TabHot from "./../common/hot/hot";
    import TabXpss from "./../common/xpss/xpss";
    import {getDeptId, getDeptName} from "../../utils/auth";

    export default {
        components: {
            Lunbo,
            TabCats,
            TabMs,
            TabBp,
            TabPlus,
            TabVideos,
            TabHot,
            TabXpss
        },
        data() {
            return {
                deptId: '',
                deptName: '',
                name: '',
                homes: [],
                kfUrl: '',
            };
        },
        async created() {
            document.title = getDeptName()
            this.deptId = getDeptId()
            this.getSpmGns()
        },
        methods: {
            async getSpmGns() {
                let data = {
                    deptId: this.deptId,
                    route: '/home'
                }
                let res = await this.$get("/spm/getSpmGns", data)
                this.homes = res.list
                this.kfUrl = res.kfUrl
            },
            //跳转客服
            toKF() {
                if (this.kfUrl) {
                    window.location.href = this.kfUrl
                }
            },
            onSearch() {

            },
        },
    };
</script>

<style lang="scss" scoped>
    .layout-container {
        margin: 0 auto;
        height: 100%;
        position: relative;
        overflow: scroll;
        padding-bottom: 49px;
    }

    .tab-items {
        /*margin-bottom: 5px;*/
    }

    .kefu {
        position: fixed;
        right: 15px;
        bottom: 60px;
        font-size: 20px;
        width: 35px;
        height: 35px;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        border-radius: 30px;
        background-color: #ffffff;
        box-shadow: 0px 0px 2px 1px rgba(0, 0, 0, 0.4);
    }
</style>
